import type { ComponentUsingTool } from '@reach/shared-types/agent-components';
import { Link } from 'react-router-dom';
import { componentPath } from '../../agents/agent-component-paths';
import { COMPONENT_TYPE_COPY } from '../../agents/agents-copy';
import styles from './ComponentsUsingToolList.module.css';

interface ComponentsUsingToolListProps {
  components: ComponentUsingTool[];
}

export const ComponentsUsingToolList = ({ components }: ComponentsUsingToolListProps) => {
  const listedComponents = components.map(({ componentId, name, type }) => ({
    componentId,
    name,
    typeLabel: COMPONENT_TYPE_COPY[type].typeLabel,
    path: componentPath(type, componentId),
  }));

  return (
    <ul className={styles.componentsUsingToolList}>
      {listedComponents.map(({ componentId, name, typeLabel, path }) => (
        <li key={componentId}>
          <span>{typeLabel}</span>
          <Link to={path}>{name}</Link>
        </li>
      ))}
    </ul>
  );
};
